import * as tslib_1 from "tslib";
import { Setting, } from '@app-state';
import { FeatureFlag, NugetType, } from '@models';
import { ODataGridComponent } from '@pages/generics/grid';
import { CommonNugetService } from '@services';
import cloneDeep from 'lodash-es/cloneDeep';
import { merge } from 'rxjs';
import { NugetUploadModalComponent, NugetVersionsModalComponent, NugetViewerModalComponent, } from '../../modals';
var NugetGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NugetGridComponent, _super);
    function NugetGridComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createPermission = '';
        _this._commonNugetService = _this._injector.get(CommonNugetService);
        return _this;
    }
    Object.defineProperty(NugetGridComponent.prototype, "showUploadButton", {
        get: function () {
            if (this._appState.user.authState === 1 /* LoggedInAsTenant */ &&
                this.type === NugetType.Libraries &&
                this._appState.settings.get(Setting.librariesUseSharedFeed) &&
                !this._appState.settings.get(Setting.librariesAllowTenantPublish)) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NugetGridComponent.prototype, "showViewer", {
        get: function () {
            return this.type === NugetType.Packages &&
                this._appState.settings.isFeatureEnabled(FeatureFlag.PackagesViewer) &&
                this._commonNugetService.isNugetDownloadEnabled(this.type);
        },
        enumerable: true,
        configurable: true
    });
    NugetGridComponent.prototype.showVersions = function (entry) {
        var _this = this;
        var clone;
        if (entry) {
            clone = cloneDeep(entry);
        }
        this._modal
            .openModal(NugetVersionsModalComponent, clone, {
            data: {
                type: this.type,
            },
        })
            .afterClosedResult()
            .subscribe(function (res) {
            switch (res.type) {
                case 3 /* Remove */:
                    _this._refresh$.next();
                    break;
            }
        });
    };
    NugetGridComponent.prototype.openUploadModal = function () {
        var _this = this;
        var modalRef = this._modal
            .openModal(NugetUploadModalComponent, null, {
            data: {
                type: this.type,
            },
        });
        merge(modalRef.customEvent, modalRef.afterClosedResult()).subscribe(function (res) {
            if ([1 /* Add */, 2 /* Update */].includes(res.type)) {
                _this._refresh$.next();
            }
        });
    };
    NugetGridComponent.prototype.openNugetViewerModal = function (entry) {
        var modalOptions = {
            data: {
                type: this.type,
            },
            size: 'xl',
            position: {
                top: '0px',
            },
            additionalClasses: ['nuget-viewer'],
            overflow: false,
        };
        this._modal.openModal(NugetViewerModalComponent, entry, modalOptions);
    };
    return NugetGridComponent;
}(ODataGridComponent));
export { NugetGridComponent };
